import React, { Component } from 'react'
import {
    Container, Spinner, Col, Row
} from 'reactstrap'
import Usuario from '../utilitarios/usuario'
import './infoUsuario.css'
const usuario = new Usuario


export default class InfoUsuario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        }
    }

    componentDidMount() {
        const _this = this
        usuario.leerUsuario(this.props.match.params.uid).then(u => {
            _this.setState({ user: u })
        })
    }




    render() {
        return (
            <Container>
                {
                    this.state.user ?
                        <div className="InfoUsuario">
                            <Row>
                                <Col xs="2" className="text-right">
                                    <img className="InfoUsuarioImg" src={this.state.user.Foto}></img>
                                </Col>
                                <Col>
                                    <h2>{this.state.user.Nombre}</h2> {' '}
                                    <p><strong>Correo: </strong>{this.state.user.Correo}</p>
                                    <p><strong>Puntos: </strong>{this.state.user.Puntos}</p>
                                </Col>
                            </Row>


                        </div>
                        :
                        <div className="CargandoInfoUsuario">
                            <Spinner />{' '}
                            Cargando...
                        </div>
                }
            </Container>
        )
    }

}